import SchoolFacilities from "./SchoolFacilities";

export default SchoolFacilities;
